import type { IOrderState } from '../../Flux/Slice/Order/OrderSlice.js'
import { EPrimerSearchStatus } from '../../Flux/Slice/Order/OrderSlice.js'
import { v4 as uuidv4 } from 'uuid'
import type { FactoryContext } from './tourTypes.js'
import type { IOrder, ISamplePool } from 'Model/index.js'

const exampleOrder1: (context: FactoryContext) => IOrder = (context) => ({
  id: uuidv4(),
  type: 'active',
  name: 'Example Order',
  createdByUser: context.user.id,
  targetTaxonomy: 'CO1_ANIMAL',
  processingType: 'METABARCODING',
  allowSingletons: false,
  lab: context.user.org.id,
  sampleConfiguration: 'SINGLE_SAMPLE_PAIRS'
})

const exampleDataset1: (context: FactoryContext, orderId: string) => ISamplePool = (context, orderId) => ({
  id: uuidv4(),
  samples: [],
  negativeControls: [],
  orderId
})

export const example1: (context: FactoryContext) => IOrderState = (context) => {
  const order = exampleOrder1(context)
  const pool = exampleDataset1(context, order.id)

  return {
    otuProcessingData: null,
    otuProcessingDataSettled: false,
    openRequests: [],
    order: exampleOrder1(context),
    dataset: { [pool.id]: pool },
    sampleMetaDatas: [],
    primer: undefined,
    primerNotFound: EPrimerSearchStatus.IN_PROGRESS,
    samplePools: [pool],
    orders: [],
    total: 0,
    postprocessingData: null,
    pipelineState: null,
    intermediatesStatus: null,
    notices: null,
    reprocessingGrant: null,
    organizations: { [context.user.org.id]: context.user.org },
    users: { [context.user.id]: context.user },
    otuCount: null,
    showSubmitInfo: false,
    showMultiqcModal: false,
    showFileModal: false
  }
}

export const exampleStates: Record<string, (context: FactoryContext) => IOrderState> = {
  EXAMPLE1: example1
}
